// Imports
import { ExtraUserDropdownItem } from '../components/top-bar/user-dropdown';
import {
	ToggleSidebarAction,
	HideSidebarAction,
	ReplaceExtraUserDropdownItems,
	PWAActiveAction,
	NewVersionIsAvailableAction,
	TOGGLE_SIDEBAR,
	HIDE_SIDEBAR,
	REPLACE_EXTRA_USER_DROPDOWN_ITEMS,
	PWA_ACTIVE,
	NEW_VERSION_IS_AVAILABLE,
} from './types';


// Exports
const adminUIActions = {
	// Handles toggling the sidebar on mobile
	toggleSidebar(): ToggleSidebarAction {
		return {
			type: TOGGLE_SIDEBAR,
		};
	},
	
	
	// Handles hiding the sidebar on mobile
	hideSidebar(): HideSidebarAction {
		return {
			type: HIDE_SIDEBAR,
		};
	},
	
	
	// Handles replacing the array of extra user dropdown items
	replaceExtraUserDropdownItems(items: ExtraUserDropdownItem[]): ReplaceExtraUserDropdownItems {
		return {
			type: REPLACE_EXTRA_USER_DROPDOWN_ITEMS,
			items: items,
		};
	},
	
	
	// Indicates app is running as a PWA
	pwaActive(): PWAActiveAction {
		return {
			type: PWA_ACTIVE,
		};
	},
	
	
	// Indicates a new version of the app is available
	newVersionIsAvailable(): NewVersionIsAvailableAction {
		return {
			type: NEW_VERSION_IS_AVAILABLE,
		};
	},
};

export default adminUIActions;
